import React from "react";
import DatePicker from "react-datepicker";
import { isDate } from "../../../../../wp-utils/v1";

const BDatePicker = ({ label, value, isRequired, onChange, ...props }) => {
  const handleChange = (value) => {
    onChange(new Date(value).toISOString().slice(0, 19).replace("T", " "));
  };

  return (
    <label className="input_date_picker">
      <label className="mmmbaa_label">
        {label}
        {isRequired ? <span className="required_star">*</span> : ""}
      </label>
      <DatePicker
        {...props}
        onChange={handleChange}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        className="input_text"
        shouldCloseOnSelect={true}
        shouldCloseCalendar={() => "select"}
        dateFormat="dd/MM/yyyy"
        selected={isDate(value) ? new Date(value) : new Date()}
      />
    </label>
  );
};

export default BDatePicker;
